module.exports = __webpack_public_path__ + "static/media/profile_image_mind_body_fitness.891164e7.webp";